import { AbilityBuilder, Ability } from '@casl/ability'
import { ACLObj, Actions, Permissions, Subjects } from '../types/apps/permissionTypes'

export type AppAbility = Ability<[Actions, Subjects | 'all']> | undefined

export const AppAbility = Ability as any

/**
 * Please define your own Ability rules according to your app requirements.
 * We have just shown Admin and Client rules for demo purpose where
 * admin can manage everything and client can just visit ACL page
 */
const parseRulesFor = (permissions: Permissions) => {
  const { can, rules } = new AbilityBuilder(AppAbility)

  for (const [subject, actions] of Object.entries(permissions)) {
    can(actions, subject)
  }

  return rules
}

export const buildAbilityFor = (permissions: Permissions): AppAbility => {
  return new AppAbility(parseRulesFor(permissions), {
    // https://casl.js.org/v5/en/guide/subject-type-detection
    // @ts-ignore
    detectSubjectType: object => object!.type
  })
}

export const defaultACLObj: ACLObj = {
  action: 'read',
  subject: 'all'
}

export default parseRulesFor
